module.exports = __webpack_public_path__ + "img/bp11.4a08c519.jpg";